@if (license; as l) {
  <div class="item-page-field bfs-license-field">
    <ds-metadata-field-wrapper [label]="'item.page.license' | translate">
      @if (l.infoPage) {
        <a class="dont-break-out" [routerLink]="['/info', l.infoPage]">
          @if (l.image) {
            <img class="bfs-license-image" [src]="l.image" alt="" />
          }
          <span>{{ l.label }}</span>
        </a>
      } @else if (l.externalUrl) {
        <a class="dont-break-out" [href]="l.externalUrl" target="_blank" rel="noopener noreferrer">{{ l.label }}</a>
      } @else {
        <span>{{ l.label }}</span>
      }
    </ds-metadata-field-wrapper>
  </div>
}
